import { OrderFlowRouteName } from '../../../../router/routes/orderFlow/model.js';
import { getStore } from '../../../helpers/initStore.js';

// ROOT STEPS
const getVisitOverviewTitle = () => {
    var _a;
    const store = getStore();
    return ((_a = store.state.orderFlow.draftOrder) === null || _a === void 0 ? void 0 : _a.isFulfilledByOffice)
        ? 'In-office Draw'
        : 'Visit';
};
/**
 * If a FlowTitleGetter is defined for a given route, it will be used to
 * determine the title of the page. If not, the title will be determined by
 * the title defined in routes.
 */
const orderFlowTitleGetters = {
    [OrderFlowRouteName.ORDER_FLOW_VISIT_OVERVIEW]: getVisitOverviewTitle,
};

export { orderFlowTitleGetters };
